import { ButtonRoundedSm } from '@apps-common/components/elements/button'
import {
  ModalBody,
  ModalCloseButton,
  ModalContainer,
  ModalFooter,
  ModalHeader,
  ModalHeaderContainer
} from '@apps-common/components/modals/modal'
import { ModalDismiss } from '@apps-common/config/modal'

interface IInfoModalComponentProps {
  subtitle: string
  title: string
  body: any
}

export const InfoModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: IInfoModalComponentProps
}) => {
  const { subtitle, title, body } = componentProps

  return (
    <ModalContainer innerClasses='!h-auto !min-h-0'>
      <ModalHeaderContainer>
        <div className='flex items-start justify-between'>
          <ModalHeader subtitle={subtitle} title={title} />
          <ModalCloseButton closeModal={() => onDismiss(null, ModalDismiss.Cancel)} />
        </div>
      </ModalHeaderContainer>

      <ModalBody classes='!pt-[90px]'>
        <div className='jost-light bg-surface border border-border rounded-2xl px-4 py-4'>{body}</div>
      </ModalBody>
      <ModalFooter>
        <ButtonRoundedSm
          type='button'
          text='Close'
          loading={false}
          callback={() => onDismiss(null, 'cancel')}
          className='action-neutral !grow-0'
        />
      </ModalFooter>
    </ModalContainer>
  )
}
